var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"disabled":_vm.downloading || (_vm.needsUser && !_vm.userId)},on:{"click":_vm.downloadCsv}},[(_vm.downloading)?_c('span',[_vm._v("Preparing…")]):_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }